import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import DentsuLogo from "../../assets/images/DentsuLogo.png";
import { useOktaAuth } from "@okta/okta-react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import { getApiCall, patchApiCall, userLogout } from "../Utils/Utils";
const Navbar = () => {
  const { oktaAuth, authState } = useOktaAuth();
  // const pages = ['Products', 'Pricing', 'Blog'];
  const pages = [];
  const settings = ["Logout"];
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [anchorElNotifications, setAnchorElNotifications] = React.useState(
    null
  );
  const [notifications, setNotifications] = React.useState([]);

  // Simulate fetching notifications from an API
  React.useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const url = "/api/notifications/";
        // const result = await getApiCall(oktaAuth, url, {});
        const result = []
        setNotifications(result);
      }
      catch {
        setNotifications([]);
      }

    };

    fetchNotifications();

    // Polling to update notifications every 2 min 30 seconds
    const interval = setInterval(() => {
      fetchNotifications();
    }, 300000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);
  const markAsRead = async (notificationId) => {
    try {
      const url = `/api/notifications/${notificationId}/mark-read/`;
      const response = await patchApiCall(oktaAuth, url, {});
      setNotifications((prevNotifications) =>
        prevNotifications.map((notification) =>
          notification.id === notificationId
            ? { ...notification, is_read: true }
            : notification
        )
      );
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOpenNotifications = (event) => {
    setAnchorElNotifications(event.currentTarget);
  };

  const handleCloseNotifications = () => {
    setAnchorElNotifications(null);
  };
  // const logout = async () => {
  //   oktaAuth.signOut();
  // };
  const logout = async () => {
    await userLogout(oktaAuth);  // Pass the `oktaAuth` instance from `useOktaAuth`
  };
  const darkTheme = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#1976d2",
      },
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            minHeight: "48px", // Reduced from default 64px
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            minHeight: "48px !important", // Force override Material-UI's default
            padding: "0 16px !important", // Reduced horizontal padding
          },
        },
      },
      MuiContainer: {
        styleOverrides: {
          root: {
            padding: "0 8px !important", // Reduced container padding
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={darkTheme}>
      <AppBar
        style={{
          backgroundColor: "#040406",
          height: "48px", // Fixed height
        }}
        position="static"
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ minHeight: "48px !important" }}>
            <Box
              component="a"
              href="/"
              sx={{
                mr: 1,
                display: { xs: "none", md: "flex" },
                textDecoration: "none",
                height: "48px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={DentsuLogo}
                alt="Dentsu Logo"
                style={{
                  height: "14px",
                  width: "auto",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </Box>
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="small" // Changed from large to small
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon sx={{ fontSize: "1.25rem" }} /> {/* Smaller icon */}
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ display: { xs: "block", md: "none" } }}
              >
                {pages.map((page) => (
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Typography sx={{ textAlign: "center" }}>{page}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>

            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              {pages.map((page) => (
                <Button
                  key={page}
                  onClick={handleCloseNavMenu}
                  sx={{
                    my: 0.5, // Reduced vertical margin
                    color: "white",
                    display: "block",
                    padding: "4px 8px", // Reduced padding
                  }}
                >
                  {page}
                </Button>
              ))}
            </Box>

            <Box sx={{ flexGrow: 0 }}>
              {/* Notifications */}
              <Tooltip style={{ marginRight: "15px" }} title="Notifications">
                <IconButton
                  onClick={handleOpenNotifications}
                  color="inherit"
                  sx={{ p: 0.5 }}
                >
                  <Badge
                    badgeContent={
                      notifications.filter((n) => !n.is_read).length
                    }
                    color="error"
                  >
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
              </Tooltip>

              {/* NEW MENU for notifications */}
              <Menu
                sx={{ mt: "45px" }}
                id="notifications-menu"
                anchorEl={anchorElNotifications}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElNotifications)}
                onClose={handleCloseNotifications}
                PaperProps={{
                  sx: { backgroundColor: "white" },
                }}
              >

                {notifications.length > 0 ? (
                  notifications
                    .filter((notification) => !notification.r) // Filter out read notifications
                    .map((notification) => (
                      <MenuItem
                        key={notification.id}
                        onClick={() => markAsRead(notification.id)}
                        sx={{
                          color: notification.is_read ? "gray" : "black",
                          backgroundColor: notification.is_read
                            ? "transparent"
                            : "rgba(0, 0, 0, 0.05)",
                          borderRadius: "4px",
                          padding: "8px 16px",
                          marginBottom: "4px",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.1)",
                            cursor: "pointer",
                          },
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: notification.is_read
                              ? "normal"
                              : "bold",
                            color: notification.is_read ? "gray" : "black",
                            flex: 1,
                          }}
                        >
                          {notification.message}
                        </Typography>
                      </MenuItem>
                    ))
                ) : (
                  <MenuItem sx={{ padding: "12px" }}>
                    <Typography
                      variant="body2"
                      sx={{ fontStyle: "italic", color: "gray" }}
                    >
                      No new notifications
                    </Typography>
                  </MenuItem>
                )}
              </Menu>

              {/* Admin Settings */}
              <Tooltip title="Open settings">
                <IconButton
                  onClick={handleOpenUserMenu}
                  sx={{
                    p: 0.5, // Reduced padding
                  }}
                >
                  <Avatar
                    alt="A"
                    sx={{
                      width: 24, // Smaller avatar
                      height: 24,
                    }}
                  />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting}
                    onClick={logout}
                    sx={{ py: 1 }} // Reduced vertical padding
                  >
                    <Typography sx={{ textAlign: "center" }}>
                      {setting}
                    </Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </ThemeProvider>
  );
};

export default Navbar;
